import React, { useState, useEffect } from "react";
import { TextField, Radio, Checkbox } from "final-form-material-ui";
import { Field } from "react-final-form";
import {
  List,
  SimpleDialog,
  CrudForm,
  crudFormEnums,
  loopback,
  DatePicker,
  Autocomplete,
  MountEntity,
  autocompleteHelpers,
  ListApi,
  FormApi,
} from "elentari";
import { notificacoesApi, clienteApi, servicosApi } from "../../services/Api";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import SendIcon from "@material-ui/icons/Send";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";

const { toOption } = autocompleteHelpers;
const { loopbackFilters } = loopback;

export function NotificacaoList(props) {
  const listOptions = {
    defaultOrder: "id",
    fields: {
      id: {
        label: "Id",
      },
      data: {
        label: "Data",
        format: (date) => (date ? moment(date).format("DD/MM/YYYY") : ""),
      },
      titulo: {
        label: "Titulo",
      },
      tipo: {
        tipo: "Tipo",
      },
    },
  };

  return (
    <ListApi api={notificacoesApi}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          labelNew="Adicionar"
          deleteItem={handleDelete}
          onClickEdit={(item) => props.history.push(`/notificacoes/${item.id}`)}
          onClickNew={() => props.history.push("/notificacoes/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function NotificacaoForm(props) {
  const [segmentacao, setSegmentacao] = useState(null);
  const [messageSent, setEnviaNotificacaoMessage] = useState("");
  const [statusNotificacao, setStatusNotificacao] = useState(null);
  const [servicos, setServicos] = useState([]);
  const [countQuery, setCountQuery] = useState(null);
  const [errorOnSendMessage, setErrorOnSendMessage] = useState(null);

  const fetchServicos = async () => {
    const response = await servicosApi.getList();
    if (response.ok) {
      setServicos(response.data);
    }
  };

  const fetchCountQuery = async () => {
    if (Number(props.match.params.id)) {
      const response = await notificacoesApi.queryCount(
        Number(props.match.params.id)
      );
      if (response.ok) {
        setCountQuery(response.data.countFcmTokens);
      }
    }
  };

  useEffect(() => {
    fetchServicos();
  }, []);

  useEffect(() => {
    fetchCountQuery();
  }, null);

  const validateSegmentacaoClientes = (values) =>
    values.clientes && values.clientes.length > 0 ? undefined : "Obrigatório";

  const validateSegmentacaoOthers = () =>
    segmentacao ? undefined : "Obrigatório";

  const validateSegmentacao = (values) =>
    segmentacao === "clientes"
      ? validateSegmentacaoClientes(values)
      : validateSegmentacaoOthers();

  const validate = (values) => ({
    mensagem: values.mensagem ? undefined : "Obrigatório",
    titulo: values.titulo ? undefined : "Obrigatório",
    tipo: validateSegmentacao(values),
  });

  const customActions = [
    {
      label: statusNotificacao === "ENVIADA" ? "Reenviar" : "Enviar",
      icon: <SendIcon style={{ marginLeft: 10 }} />,
      onClick: () =>
        setEnviaNotificacaoMessage(
          `Tem certeza de que deseja enviar a notificação? Ela irá atingir ${countQuery} aparelho(s).`
        ),
      pristine: crudFormEnums.PRISTINE_BEHAVIOR.DISABLED_WHEN_DIRTY,
    },
  ];

  const loadClientes = async (inputValue) => {
    const response = await clienteApi.getOnlyWithFcmToken({
      where: {
        nome: loopbackFilters.regexp(inputValue),
      },
      order: "nome asc",
      limit: 40,
    });
    if (response.ok) {
      return response.data.map(toOption("nome"));
    }
    return [];
  };

  const handleChange = (event) => setSegmentacao(event.target.value);

  const renderClientes = () => (
    <Field
      isMulti
      fullWidth
      loadOptions={loadClientes}
      component={Autocomplete}
      label="Clientes"
      name="clientes"
    />
  );

  const getItem = async () => {
    let clienteIds = [];
    let filtros = {};
    if (Number(props.match.params.id)) {
      const notificacao = await notificacoesApi.getOne(props.match.params.id);
      const { tipo, query, status } = notificacao.data;
      setSegmentacao(tipo);
      setStatusNotificacao(status);
      if (tipo === "clientes") {
        clienteIds = notificacao.data.query.split(",").map((e) => Number(e));
      }
      if (tipo === "filtros") {
        filtros = JSON.parse(query);
      }
    }
    return MountEntity(props, notificacoesApi.getOne)
      .populate(({ id, data }) => {
        return {
          clientes: clienteIds.map((id) => clienteApi.getOne(id)),
        };
      })
      .map((data) => {
        return {
          ...data,
          ...filtros,
          clientes: data.clientes.map(toOption("nome")),
        };
      })
      .getItem();
  };

  const renderFiltros = () => (
    <Grid container direction="column" spacing={16}>
      <Grid item sm>
        <FormControl component="fieldset" style={{ width: "100%" }}>
          <FormLabel component="legend">Situação</FormLabel>
          <FormGroup row>
            <Grid container style={{ width: "100%" }}>
              {[
                { descricao: "Todos", value: "todos" },
                { descricao: "Ativo", value: "ativo" },
                { descricao: "Inativo", value: "inativo" },
              ].map((item) => (
                <Grid item sm={2} key={item.descricao}>
                  <FormControlLabel
                    label={item.descricao}
                    control={
                      <Field
                        color="primary"
                        name="situacao"
                        type="radio"
                        value={item.value}
                        component={Radio}
                      />
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid item sm>
        <FormControl component="fieldset" style={{ width: "100%" }}>
          <FormLabel component="legend">Serviços</FormLabel>
          <FormGroup row>
            <Grid container style={{ width: "100%" }}>
              {servicos.map((item) => (
                <Grid item sm={2} key={item.descricao}>
                  <FormControlLabel
                    label={item.nome}
                    control={
                      <Field
                        color="primary"
                        name="servicos"
                        value={item.id}
                        type="checkbox"
                        component={Checkbox}
                      />
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid item>
        <Grid container spacing={16}>
          <Grid item sm={4}>
            <Field
              label="Data Última Acesso Início"
              fullWidth
              component={DatePicker}
              name="dataInicio"
            />
          </Grid>
          <Grid item style={{ alignSelf: "flex-end" }}>
            <Typography>Até</Typography>
          </Grid>
          <Grid item sm={4}>
            <Field
              label="Data Última Acesso Fim"
              fullWidth
              component={DatePicker}
              name="dataFim"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  const submitDecorator = async ({ id, data, handleSubmit }) => {
    let result = {};
    let formattedValues = {
      titulo: data.titulo,
      mensagem: data.mensagem,
      tipo: segmentacao,
      status: "PENDENTE",
    };

    if (segmentacao === "clientes") {
      result = await handleSubmit({
        id,
        data: {
          ...formattedValues,
          query: data.clientes.map((cliente) => cliente.id),
        },
      });
    } else if (segmentacao === "filtros") {
      result = await handleSubmit({
        id,
        data: {
          ...formattedValues,
          query: JSON.stringify({
            situacao: data.situacao ? data.situacao : undefined,
            servicos: data.servicos ? data.servicos : undefined,
            dataInicio: data.dataInicio ? data.dataInicio : undefined,
            dataFim: data.dataFim ? data.dataFim : undefined,
          }),
        },
      });
    } else {
      result = await handleSubmit({
        id,
        data: {
          ...formattedValues,
        },
      });
    }
    return result;
  };

  const getItemDecorator = async ({ getItem }) => {
    const item = await getItem();
    setSegmentacao(item.tipo);
    return {
      ...item,
    };
  };

  const enviarNotificacao = async () => {
    const id = props.match.params.id;
    const response = await notificacoesApi.send(id);
    if (!response.ok) setErrorOnSendMessage(true);
  };

  return (
    <div>
      <FormApi
        {...props}
        submitDecorator={submitDecorator}
        getItemDecorator={getItemDecorator}
        api={notificacoesApi}
      >
        {({ handleSubmit }) => (
          <CrudForm
            withPaper
            validate={validate}
            customActions={props.match.params.id !== "new" ? customActions : []}
            history={props.history}
            getItem={getItem}
            onSubmit={handleSubmit}
          >
            <Grid container direction="column" spacing={16}>
              <Grid item sm>
                <Field
                  fullWidth
                  component={TextField}
                  label="Título"
                  name="titulo"
                />
              </Grid>
              <Grid item>
                <Field
                  fullWidth
                  component={TextField}
                  label="Mensagem"
                  name="mensagem"
                />
              </Grid>
              <Grid item sm>
                <Grid item sm>
                  <FormLabel>Público Alvo</FormLabel>
                </Grid>
                <Grid item sm>
                  <Select fullWidth value={segmentacao} onChange={handleChange}>
                    <MenuItem value="">
                      <em>Público Alvo</em>
                    </MenuItem>
                    <MenuItem value={"clientes"}>Por cliente</MenuItem>
                    <MenuItem value={"filtros"}>Por filtros</MenuItem>
                    <MenuItem value={"todos"}>Todos</MenuItem>
                    <MenuItem value={"visitantes"}>Somente Visitantes</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid item sm>
                <Grid container>
                  <Grid item sm>
                    {segmentacao === "clientes" ? renderClientes() : null}
                    {segmentacao === "filtros" ? renderFiltros() : null}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CrudForm>
        )}
      </FormApi>
      <SimpleDialog
        title="Atenção"
        message={messageSent}
        open={!!messageSent}
        buttonLabel="Não"
        primaryAction={enviarNotificacao}
        primaryActionButtonLabel="Sim"
        handleClose={() => setEnviaNotificacaoMessage(null)}
      />
      <SimpleDialog
        title="Atenção"
        message="Ocorreu um erro no envio da mensagem, por favor tente novamente mais tarde."
        open={errorOnSendMessage}
        primaryActionButtonLabel="Ok"
        handleClose={() => setErrorOnSendMessage(null)}
      />
    </div>
  );
}
